import React, { useMemo } from "react";
import { Modal, Table } from "react-bootstrap";
import dateFormat from "dateformat";
import DashMedidasButton from "./DashMedidasButton/DashMedidasButton";
import {
  formatMetadataValue,
  getMeasureMetadata,
  getMeasureProcessLabel,
  metadataFieldLabel,
} from "../../../utils/measureFields";

const buildMetadataRows = (measure) => {
  if (!measure) return [];

  const rows = [];
  const process = getMeasureProcessLabel(measure);
  if (process && process !== "--") {
    rows.push({ key: "process", label: "Processo", value: process });
  }

  Object.entries(getMeasureMetadata(measure)).forEach(([key, value]) => {
    const formatted = formatMetadataValue(value);
    if (formatted !== "--") {
      rows.push({
        key,
        label: metadataFieldLabel(key),
        value: formatted,
      });
    }
  });

  return rows;
};

const MeasureMetadataModal = ({ show, measure, onHide }) => {
  const rows = useMemo(() => buildMetadataRows(measure), [measure]);

  const titleDate = measure?.date
    ? dateFormat(measure.date, "UTC:dd/mm/yy' 'HH:MM")
    : "Medição";

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      scrollable
      dialogClassName="dash-metadata-modal__dialog"
      className="dash-medidas-modal dash-metadata-modal"
    >
      <Modal.Header closeButton className="dash-metadata-modal__header">
        <Modal.Title className="dash-metadata-modal__title">
          Informações da medição
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="dash-metadata-modal__body">
        <p className="dash-metadata-modal__datetime mb-3">{titleDate}</p>
        {measure?.grain ? (
          <p className="dash-metadata-modal__grain mb-3">
            <span className="dash-metadata-modal__grain-label">Grão:</span>{" "}
            {measure.grain}
          </p>
        ) : null}

        {rows.length ? (
          <Table
            bordered
            responsive
            size="sm"
            className="dash-metadata-modal__table mb-0"
          >
            <tbody>
              {rows.map((row) => (
                <tr key={row.key}>
                  <th scope="row">{row.label}</th>
                  <td>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="mb-0 text-muted">Nenhum dado adicional disponível.</p>
        )}
      </Modal.Body>
      <Modal.Footer className="dash-metadata-modal__footer">
        <DashMedidasButton variant="outline-secondary" onClick={onHide}>
          Fechar
        </DashMedidasButton>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(MeasureMetadataModal);
